export default __webpack_public_path__ + "static/media/C2.7ff142b8.png";